import React from 'react';
import MenuMain from '../../MenuMain';
import { FormRotas } from '../../components/FormRotas';
import { AppFooter } from '../../AppFooter';


export default function CadastrarRotaPage() {

  const defaultValues = {
    'nome': ''
  }

  return (
    <div>
      <MenuMain>
         <FormRotas
          defaultValues={defaultValues}
        />
      </MenuMain>
      <AppFooter />
    </div>
  );
}

